export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-CD-01',
        data: [
            {
                "cross_section": 42127,
                "type": "Culvert",
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "20",
                        "compare": "21"
                    },
                    {
                        "name": "Weir Coef",
                        "base": "3",
                        "compare": "3.5"
                    }
                ],
                "sloping_diff": [],
                "pier_diff": [],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [
                        {
                            "name": "Distance",
                            "base": "20",
                            "compare": "21"
                        },
                        {
                            "name": "Weir Coef",
                            "base": "3",
                            "compare": "3.5"
                        }
                    ],
                    [],
                    [],
                    [],
                    []
                ]
            },
            {
                "cross_section": 37860,
                "type": "Culvert",
                "deck_dist_diff": [
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "sloping_diff": [],
                "pier_diff": [],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [
                        {
                            "name": "Chord Station Elevation Data",
                            "base": "*",
                            "compare": "*"
                        }
                    ],
                    [],
                    [],
                    [],
                    []
                ]
            },
            {
                "cross_section": 36007,
                "type": "Culvert",
                "deck_dist_diff": [
                    {
                        "name": "D.S Embankment SS",
                        "base": "1",
                        "compare": "1.5"
                    }
                ],
                "sloping_diff": [],
                "pier_diff": [],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [
                        {
                            "name": "D.S Embankment SS",
                            "base": "1",
                            "compare": "1.5"
                        }
                    ],
                    [],
                    [],
                    [],
                    []
                ]
            },
            {
                "cross_section": 30117,
                "type": "Bridge",
                "deck_dist_diff": [
                    {
                        "name": "Weir Crest Shape",
                        "base": "Broad Crested",
                        "compare": "Ogee"
                    }
                ],
                "sloping_diff": [],
                "pier_diff": [],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [
                        {
                            "name": "Weir Crest Shape",
                            "base": "Broad Crested",
                            "compare": "Ogee"
                        }
                    ],
                    [],
                    [],
                    [],
                    []
                ]
            },
            {
                "cross_section": 23668,
                "type": "Bridge",
                "deck_dist_diff": [],
                "sloping_diff": [],
                "pier_diff": [
                    {
                        "pier": "Pier#1",
                        "diffs": [
                            {
                                "name": "Width-Elevation Data",
                                "base": "*",
                                "compare": "*"
                            }
                        ]
                    }
                ],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [],
                    [],
                    [
                        {
                            "pier": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        }
                    ],
                    [],
                    []
                ]
            },
            {
                "cross_section": 2134,
                "type": "Culvert",
                "deck_dist_diff": [
                    {
                        "name": "Min Weir Flow",
                        "base": "119.83",
                        "compare": "119.8"
                    }
                ],
                "sloping_diff": [],
                "pier_diff": [],
                "culvert_diff": [],
                "inline_structure_diff": [],
                "structure_diffs": [
                    [
                        {
                            "name": "Min Weir Flow",
                            "base": "119.83",
                            "compare": "119.8"
                        }
                    ],
                    [],
                    [],
                    [],
                    []
                ]
            }
        ]
    }
]